
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAnalog25 as ObiTwowayAnalog25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-analog-25.js';
 
 
 

 
 export const ObiTwowayAnalog25 = createComponent({
   react: React,
   tagName: 'obi-twoway-analog-25',
   elementClass: ObiTwowayAnalog25Element,
   events: {
     
   }
  });
 
 